<div [ngClass]="{ columnInput: isColumn(), rowInput: isRow() }">
  <label *ngIf="label" for="{{ itemId }}" title="{{ label }}">{{
    label
  }}</label>
  <input
    id="{{ itemId }}"
    type="text"
    [(ngModel)]="value"
    placeholder="{{ placeholder }}"
    maxlength="{{ maxLength }}"
    (input)="onInput($event)"
    (keyup)="onKeyUp($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnterClickedEventHandler()"
    #inputElement
    [dir]="inputDirection"
  />
</div>
